(function () {
  'use strict';

  const header = document.querySelector('.rf-header');
  const subnav = document.querySelector('[data-rf-vault-subnav]');

  function isStickyHeader() {
    if (!header) return false;
    return header.hasAttribute('data-rf-sticky') ||
           getComputedStyle(header).position === 'sticky';
  }

  function setOffsets() {
    const headerH = isStickyHeader() ? header.offsetHeight : 0;
    document.documentElement.style.setProperty('--rf-vault-header-h', headerH + 'px');
    const subnavH = subnav ? subnav.offsetHeight : 0;
    document.documentElement.style.scrollPaddingTop = (headerH + subnavH + 16) + 'px';
  }

  setOffsets();
  window.addEventListener('resize', setOffsets);
  window.addEventListener('load', setOffsets);

  const sections = document.querySelectorAll('[data-rf-vault-shelf]');
  const links = document.querySelectorAll('[data-rf-vault-section]');

  if (sections.length && links.length && 'IntersectionObserver' in window) {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          const id = entry.target.id;
          links.forEach((link) => {
            link.classList.toggle('is-active', link.dataset.rfVaultSection === id);
          });
        }
      });
    }, { rootMargin: '-30% 0px -55% 0px' });
    sections.forEach((s) => observer.observe(s));
  }

  const finePointer = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  if (finePointer) {
    document.querySelectorAll('[data-rf-vault-scroller]').forEach((scroller) => {
      let isDown = false, startX = 0, scrollLeft = 0, moved = false;

      scroller.addEventListener('mousedown', (e) => {
        isDown = true;
        moved = false;
        startX = e.pageX - scroller.offsetLeft;
        scrollLeft = scroller.scrollLeft;
      });
      scroller.addEventListener('mouseleave', () => { isDown = false; });
      scroller.addEventListener('mouseup', () => { isDown = false; });
      scroller.addEventListener('mousemove', (e) => {
        if (!isDown) return;
        e.preventDefault();
        const x = e.pageX - scroller.offsetLeft;
        const walk = (x - startX) * 1.5;
        if (Math.abs(walk) > 5) moved = true;
        scroller.scrollLeft = scrollLeft - walk;
      });
      scroller.addEventListener('click', (e) => {
        if (moved) e.preventDefault();
      }, true);
    });
  }
})();
